import { Box, Typography, Tooltip } from '@mui/material';
import { TagType } from 'src/features/sites/types/types';
import { LabelingTypeEnum } from 'src/types';
import { UserDefinedValue } from 'src/types/controllers/controller';

type Props = {
  label: string;
  liveDataComplete: any;
  id: string;
  restTags: TagType[];
};

export const LabelAndValue = ({ label, liveDataComplete, id, restTags }: Props) => {
  const liveDataTag = liveDataComplete?.tags?.find((item: TagType) => item.id === id);
  const restTag = restTags?.find((tag) => tag.id === id);

  const userDefinedValues: UserDefinedValue[] =
    restTag?.advancedTagMapping?.userDefinedValues ?? [];
  const labellingType: LabelingTypeEnum = liveDataTag?.labbelingType || restTag?.labellingType;
  const fallbackValue: string = liveDataTag?.fallbackValue || restTag?.fallbackValue;

  let tagValue: string | number = Number(liveDataTag?.value || restTag?.value);

  //labelyingType
  const findUserDefinedItem = userDefinedValues?.find((item) => Number(item.value) === tagValue);

  if (labellingType === LabelingTypeEnum.LABEL) {
    if (!findUserDefinedItem) {
      tagValue = fallbackValue;
    } else {
      const name = findUserDefinedItem?.name;
      tagValue = name ?? fallbackValue;
    }
  }
  if (labellingType === LabelingTypeEnum.VALUE_LABEL) {
    if (!findUserDefinedItem) {
      tagValue = fallbackValue;
    } else {
      const name = findUserDefinedItem?.name;
      const value = findUserDefinedItem?.value;
      tagValue = `${value}-${name}`;
    }
  }

  const MAX_VISIBLE_CHARS = String(tagValue)?.length > 3 ? 18 : 20;
  const MIN_CHARS_FOR_ELLIPSIS = String(tagValue)?.length > 3 ? 20 : 22;

  const getDisplayLabel = (label: string) => {
    if (label.length >= MIN_CHARS_FOR_ELLIPSIS) {
      return `${label.slice(0, MAX_VISIBLE_CHARS)}...`;
    }

    return label;
  };

  const displayLabel = getDisplayLabel(label);

  return (
    <Box sx={{ display: 'flex' }}>
      <Tooltip title={`${label}: ${tagValue}`} placement="top-end">
        <Typography sx={{ fontSize: '13px' }} data-sm={`${restTag?.id}-${tagValue}`}>
          {displayLabel ? `${displayLabel}: ${tagValue}` : tagValue}
        </Typography>
      </Tooltip>
    </Box>
  );
};
